import {  Heading, VStack, HStack, Box, Text, Icon, Image} from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import FullScreenSection from "./FullScreenSection";
import { ChakraProvider, Flex, Link } from "@chakra-ui/react";
import { ConversionBox } from "./ConversionBox";
import { CheckCircleIcon } from "@chakra-ui/icons";
import DownloadApp from "./DownloadApp";
import TransferSteps from "./TransferSteps";
import ExchangeSteps from "./ExchangeSteps";
import MultiCurrency from "./MultiCurrency";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";


const currencyFlows = [
  ["CAD", "NGN"],
  ["NGN", "CAD"],
  ["USD", "NGN"],
  ["NGN", "USD"],
  ["GBP", "NGN"],
  ["NGN", "GBP"],
  ["EUR", "NGN"],
  ["NGN", "EUR"],
  ["CAD", "USD"],
  ["USD", "CAD"],
];

const flagMap = {
  CAD: "/flags/ca.png",
  NGN: "/flags/ng.png",
  USD: "/flags/us.png",
  GBP: "/flags/gb.png",
  EUR: "/flags/eu.png",
};

const flowMarquee = keyframes`
  0% { transform: translateX(-50%); }
  100% { transform: translateX(0); }
`;



const MoneyTransfer = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  }, [location]);
  
return (
<VStack>
  <FullScreenSection
    id="international-transfers"
    justifyContent="center"
    alignItems="center"
    isDarkBackground = {false}
    backgroundImage={`url(${require('../images/landingPageBgFlipped.png')})`}
    backgroundSize="cover"
    backgroundPosition="center center"
    backgroundRepeat="no-repeat"
    py={100}
    overlay={true}
    overlayColor="whiteAlpha.800"
  >
    <Flex
      minH="30vh"
      align="center"
      justify="center"
      bg="transparent"
      position="relative"
      direction={{ base: "column", lg: "row" }}
      gap={{ base: 10, lg: 0 }}
      w="100%"
      px={{ base: 4, md: 0 }}
      
    >
    
      <VStack
        spacing={{ base: 1, md: 3, lg: 4 }}
        alignItems={{ base: "center", lg: "flex-start" }}
        textAlign={{ base: "center", lg: "left" }}
        m={{ base: 0, lg: 20 }}
        mb={{ base: 0, lg: 100 }}
        w="100%"
        
      >
        
        <Heading
          fontFamily="Lora, serif"
          fontSize={{ base: "1.8rem", md: "2.8rem", lg: "3.2rem" }}
          fontWeight="extrabold"
          mb={{ base: 6, lg: 10 }}
        >
           Transfer money accross border
           <Text as="span" display={{ base: "none", md: "inline" }}> <br /> </Text>
           @ zero fees 
        </Heading>
      
        <Heading
          fontFamily="merriweather"
          fontSize={{ base: "1rem", md: "1.2rem", lg: "1.3rem" }}
          fontWeight={200}
        >
          Send money from Canada to{/*USA, UK,*/} Nigeria
        </Heading>
        {/*<Box w={{ base: "100%", md: "520px" }} overflow="hidden" mt={2} mb={-4}>
          <Flex
            gap={3}
            whiteSpace="nowrap"
            animation={`${flowMarquee} 36s linear infinite`}
            w="max-content"
          >
            {[...currencyFlows, ...currencyFlows].map(([from, to], index) => (
              <HStack
                key={`${from}-${to}-${index}`}
                spacing={2}
                bg="white"
                px={3}
                py={2}
                borderRadius="full"
                border="1px solid"
                borderColor="gray.200"
                boxShadow="sm"
                flexShrink={0}
              >
                <HStack spacing={1}>
                  <Box width="22px" height="16px" overflow="hidden" borderRadius="md">
                    <Image src={flagMap[from]} width="100%" height="100%" objectFit="cover" />
                  </Box>
                  <Text fontWeight="bold" fontSize={12}>{from}</Text>
                </HStack>
                <Text fontWeight="bold" fontSize={12} color="gray.600">→</Text>
                <HStack spacing={1}>
                  <Box width="22px" height="16px" overflow="hidden" borderRadius="md">
                    <Image src={flagMap[to]} width="100%" height="100%" objectFit="cover" />
                  </Box>
                  <Text fontWeight="bold" fontSize={12}>{to}</Text>
                </HStack>
              </HStack>
            ))}
          </Flex>
        </Box>*/}
      </VStack>
          
       <ChakraProvider>
         <Box w="100%" maxW={{ base: "100%", sm: "520px" }}  px={{ base: 2, sm: 2 }} mx={{ base: 6, lg: 12 }}>
           <ConversionBox  w="100%" marginTop={{ base: 0, lg: 10 }}  />
         </Box>
      </ChakraProvider>

      {/* Store Buttons - Bottom Left 
          <Flex direction="row" align="center" spacing={5} gap={6}
            position="absolute"
            left={{ base: 12, md: 20 }}
            bottom={{ base: 4, md: 4}}
            zIndex={2}
          >
            
            <Link href="#" _hover={{ transform: "translateY(-2px)" }}
              transition="0.15s ease"
              alignItems="center" w="fit-content"
            >
              <Image src="/PreRegisterOnGooglePlay.png" alt="Google Play" width="175px" height="58px" />
            </Link>
            
            <Link href="#" _hover={{ transform: "translateY(-2px)"}}
              transition="0.15s ease" alignItems="center"  w="fit-content"
            >
              <Image src="/Pre-order_on_the_App_Store.svg" alt="App Store" width="200px" height="60px" />
            </Link>
          </Flex> */}
                   
    </Flex>


    {/* Why Choose Swiftchange Section */}
    <VStack spacing={8} mt={{ base: 16, md: 24, lg: 32 }} mb={0} width="100%" maxW="1200px" zIndex={10}>
      <Heading fontSize={{ base: "1.9rem", md: "2.2rem", lg: "2.5rem" }} fontWeight="bold" textAlign="center">
        Why choose Swiftchang for your cross-border transfers?
      </Heading>
      
      <HStack spacing={{ base: 6, md: 8 }} flexWrap="wrap" justifyContent="center" width="100%">
        {/* Zero Fees */}
        <VStack spacing={3} flex="1" minW="200px" maxW="250px" align="center">
          <Icon as={CheckCircleIcon} boxSize={12} color="blue.500" />
          <Heading fontSize="1.2rem" fontWeight="semibold">Zero Fees</Heading>
          <Text textAlign="center" color="gray.600">
            Send money without any hidden charges or transaction fees
          </Text>
        </VStack>

        {/* Fast and Easy Transfer */}
        <VStack spacing={3} flex="1" minW="200px" maxW="250px" align="center">
          <Icon as={CheckCircleIcon} boxSize={12} color="green.500" />
          <Heading fontSize="1.2rem" fontWeight="semibold">Fast & Easy Transfer</Heading>
          <Text textAlign="center" color="gray.600">
            Complete transfers in minutes with our simple interface
          </Text>
        </VStack>

        {/* Competitive Exchange Rate */}
        <VStack spacing={3} flex="1" minW="200px" maxW="250px" align="center">
          <Icon as={CheckCircleIcon} boxSize={12} color="purple.500" />
          <Heading fontSize="1.2rem" fontWeight="semibold">Competitive Exchange Rate</Heading>
          <Text textAlign="center" color="gray.600">
            Get the best rates for your currency conversions
          </Text>
        </VStack>

        {/* Secure Transactions */}
        <VStack spacing={3} flex="1" minW="200px" maxW="250px" align="center">
          <Icon as={CheckCircleIcon} boxSize={12} color="teal.500" />
          <Heading fontSize="1.2rem" fontWeight="semibold">Secure Transactions</Heading>
          <Text textAlign="center" color="gray.600">
            Bank-level security to protect your money and data
          </Text>
        </VStack>
      </HStack>
    </VStack>

  </FullScreenSection>
  <Box id="transfer-steps">
    <TransferSteps/>
  </Box>
  <Box id="currency-swap">
    <ExchangeSteps/>
  </Box>
  <Box id="multi-currency">
    <MultiCurrency/>
  </Box>
  
          <DownloadApp />
  
    
</VStack>
);
};

export default MoneyTransfer;
